import React, { Component } from 'react';
import { connect } from 'react-redux';
import api from '../../../axios-local-api';
import Confirm from '../../../components/UI/Confirm/Confirm';
import Error from '../../../components/UI/Error/Error';
import Modal from '../../../components/UI/Modal/Modal';
import Spinner from '../../../components/UI/Spinner/Spinner';
import Success from '../../../components/UI/Success/Success';
import Switch from '../../../components/UI/Switch/Switch';
import Box from '../../../hoc/Box/Box';
import withErrorHandler from '../../../hoc/withErrorHandler/withErrorHandler';
import * as actions from '../../../store/actions/index';
import classes from './MobileHomeSwitch.css';


export class MobileHomeSwitch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      success: false,
      error: false,
      action: null,
      checked: false,
      confirmModal: false,
      result: '',
      mobileHome: null
    }
    this.handleToggleMobileHomeSwitch = this.handleToggleMobileHomeSwitch.bind(this);
  }


  componentDidMount() {
    if (this.props.mobileHome) {
      if (this.state.mobileHome !== this.props.mobileHome) {
        this.setState({ mobileHome: this.props.mobileHome, checked: this.props.mobileHome.mode && this.props.mobileHome.mode !== 'disable' ? true : false })
      }
    }
    
  }
  componentDidUpdate() {
    if (this.props.mobileHome) {
      if (this.state.mobileHome !== this.props.mobileHome) {
        this.setState({ mobileHome: this.props.mobileHome, checked: this.props.mobileHome.mode && this.props.mobileHome.mode !== 'disable' ? true : false })
      }
    }
    if(this.state.success !== this.props.success){
      this.setState({
        success:this.props.success
      })
    }
  }
  resetMobileHomeSwitch() {
  }
  handleToggleMobileHomeSwitch() {
    if (!this.state.checked) {
      const modalContent = (<div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
        <h2 style={{ whiteSpace: 'nowrap', marginBottom: '5px' }}>Enable Mobile Home?</h2>
        <p style={{ fontWeight: 'normal', margin: 0, textAlign: 'center' }}>Are you sure you want to proceed?</p>

      </div>)
      this.onOpenModal(modalContent, 'change Mobile Home');
    } else {
      const modalContent = (<div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
        <h2 style={{ whiteSpace: 'nowrap', marginBottom: '5px' }}>Disable Mobile Home?</h2>
        <p style={{ fontWeight: 'normal', margin: 0, textAlign: 'center' }}>Are you sure you want to proceed?</p>
      </div>)
      this.onOpenModal(modalContent, 'change Mobile Home');
    }


    this.setState((state) => ({ checked: !state.checked }));

  }
  successErrorResetHandler = () => {
    this.setState({ error: false, success: false });
    this.closeModal()
    this.props.onResetMobileHomeSwitchErrorSuccess()
  }
  confirmModalConfirmHandler = () => {
    this.props.onChangeMobileHomeSwitch(this.state.checked);
    this.closeModal('dontreset');
  }
  confirmModalCancelHandler = () => {
    this.resetMobileHomeSwitch()
    this.setState({ confirmModal: false, checked: this.props.mobileHome.mode && this.props.mobileHome.mode !== 'disable' ? true : false });

  }
  closeModal = (event) => {
    this.setState({ confirmModal: false });
    if (event !== 'dontreset') {
      this.setState({ checked: this.props.mobileHome.mode && this.props.mobileHome.mode !== 'disable' ? true : false })
    }
  }
  onOpenModal = (result, action) => {
    this.setState({
      confirmModal: true,
      action,
      result
    })
  }


  render() {
    // if (this.props.error && !this.state.error) {
    //   this.setState({ error: true })
    //   this.props.onResetMobileHomeSwitchErrorSuccess()
    // }
    if (!this.props.loaded || this.props.loading) {
      return (
        <div className={classes.SpinnerResize} ><Spinner /></div>
      )
    } else {
      return (
        <Box>
          <div className={classes.MobileHomeSwitch}>
            <div id='MobileHome' className={classes.TitleArea}>
              {/* <h3> Spectrum Mobile Access Point </h3> */}
              <Switch id='MobileHomeToggle'
                aria-checked={this.state.checked}
                aria-label="Toggle Mobile Home"
                checked={this.state.checked}
                onChange={this.handleToggleMobileHomeSwitch}
                
              />
             </div>
          </div>
          <Modal deviceGroupConfirmation="true" show={this.state.confirmModal} modalClosed={this.closeModal}>
            <Confirm id={'MobileHomeConfirm'}
              action={this.state.action}
              result={this.state.result}
              deviceGroupConfirmation
              confirm={this.confirmModalConfirmHandler}
              cancel={this.confirmModalCancelHandler}
              cancelButtonLabel="Cancel"
              confirmButtonLabel={this.state.checked ? 'Enable' : 'Disable'}
              hideActionText={true}
            />
          </Modal>
          <Modal show={this.props.error} modalClosed={this.successErrorResetHandler}>
            <Error id={'MobileHomeError'} errorStatus={this.props.errorStatus} showOldView />
          </Modal>
          <Modal show={this.state.success} modalClosed={this.successErrorResetHandler}>
            <Success id={'MobileHomeSuccess'} />
          </Modal>
        </Box>
      )
    }
  }
}

const mapStateToProps = (state => {
  return {
    loading: state.mobileHome.loading,
    loaded: state.mobileHome.loaded,
    success: state.mobileHome.success || false,
    mobileHome: state.mobileHome.realMobileHome,
    error: state.mobileHome.error,
    errorStatus: state.mobileHome.errorStatus,
  };
});

const mapDispatchToProps = (dispatch) => {
  return {
    onChangeMobileHomeSwitch: (newVal) => { dispatch(actions.changeMobileHome(newVal)) },
    onResetMobileHomeSwitchErrorSuccess: () => dispatch(actions.resetMobileHomeErrorSuccess())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withErrorHandler(MobileHomeSwitch, api));
